import React, { useState, useCallback, useEffect } from 'react';
import { useSelector } from 'react-redux';
import styles from './styles.module.scss';

import ApiStores from '../../../api/Stores/Stores';

import Text from '../../Input/Text';
import Expiration from '../../Input/Expiration';
// import LinkLang from '../../Wraps/LinkLang';
import loading from '../../../assets/icons/loading.gif';
import { ReactComponent as Checked } from '../../../assets/icons/icon-radio-checked.svg';
import { ReactComponent as CloseBtn } from '../../../assets/icons/icon-close.svg';

import Config, { spanish } from '../../../config/config';
import {
  numberChars,
  textChars,
} from '../../../utils/format/character_restriction';

const Form = ({
  content,
  onPaymentFormChange,
  onSubmitPayment,
  showErrorMessage,
  errorMessage,
}) => (
  <form className={styles.form}>
    <div className={styles.field}>
      <Text
        id="card-number"
        type="text"
        title={spanish ? 'Titular de la tarjeta*' : 'Card holder*'}
        onKeyPress={textChars}
        onChange={onPaymentFormChange}
        required
        readOnly
      />
    </div>
    <div className={styles.field}>
      <Text
        id="cardholder-name"
        title={spanish ? 'Número de tarjeta*' : 'Card number*'}
        onChange={onPaymentFormChange}
        onKeyPress={numberChars}
        readOnly
      />
    </div>
    <div className={styles.field} style={{ display: 'flex', gap: '10px' }}>
      <Expiration
        id="expiry-month"
        title={spanish ? 'Mes de vencimiento*' : 'Expiration Month*'}
        onChange={onPaymentFormChange}
        placeholder="MM"
      />
      <Expiration
        id="expiry-year"
        title={spanish ? 'Año de vencimiento*' : 'Expiration Year*'}
        onChange={onPaymentFormChange}
        placeholder="YY"
      />
    </div>
    <div className={styles.field}>
      <Text
        id="security-code"
        type="password"
        title={
          spanish ? 'Código de seguridad (CVV)*' : 'Card validation code (CVV)*'
        }
        placeholder="***"
        onKeyPress={numberChars}
        minLength={3}
        maxLength={3}
        onChange={onPaymentFormChange}
        required
        readOnly
      />
    </div>
    <div className={styles.error}>
      {showErrorMessage && <p>{errorMessage}</p>}
    </div>
    <div className={styles.button}>
      <button
        className="btn btn-yellow"
        type="button"
        onClick={onSubmitPayment}
      >
        {spanish ? content?.ButtonSpanish : content?.ButtonEnglish}
      </button>
    </div>
  </form>
);

const ProcessingModal = ({ content }) => (
  <div className={styles.modal}>
    <div className={styles.modalContent}>
      <p>{spanish ? content?.ProcessingSpanish : content?.ProcessingEnglish}</p>
      <img src={loading} alt="processing" />
    </div>
  </div>
);

const Loading = () => (
  <>
    <div className={styles.loading}>
      <div>
        <img src={loading} alt="loading" />
        <p>{spanish ? 'Cargando' : 'Loading'}</p>
      </div>
    </div>
    <div />
  </>
);

const ScriptEvo = ({ htmlString, status }) => {
  const evoId =
    status === 'PENDING'
      ? 'threedsChallengeRedirectForm'
      : 'threedsFrictionLessRedirect';
  const createMarkup = () => ({ __html: htmlString });
  // eslint-disable-next-line consistent-return
  useEffect(() => {
    if (htmlString) {
      const scriptContent = htmlString.match(
        /<script\b[^>]*>([\s\S]*?)<\/script>/
      )[1];
      const script = document.createElement('script');
      script.innerHTML = scriptContent;
      document.getElementById(evoId).appendChild(script);
    }
  }, [htmlString]);
  return htmlString ? <div dangerouslySetInnerHTML={createMarkup()} /> : null;
};

const StaticBackdropModal = ({ isOpen, children }) => {
  if (!isOpen) return null;

  return (
    <div className={styles.modalContainer}>
      <div className={styles.modalEvoContent}>{children}</div>
    </div>
  );
};

const Payment = ({
  content,
  onPaymentFormChange,
  onSubmitPayment,
  showErrorMessage,
  errorMessage,
  processing,
  evoHtml,
  evoResult,
  validatePayment,
  isLoading,
}) => {
  console.log(isLoading);
  const [showEvoHtml, setShowEvoHtml] = useState(
    evoResult === 'PENDING' || evoResult === 'SUCCESS'
  );
  const [modalOpen, setModalOpen] = useState(false);
  const [estadoSelected, setEstadoSelected] = useState([]);
  const shippingAddressInfo = useSelector(
    (globalState) => globalState.shippingInfo
  );

  const getStatesInfo = useCallback(async () => {
    const payload = {
      Cliente: Config.api_services.client,
      Pais: 'MEX',
      Ambiente: Config.api_services.environment,
    };
    const resp = await ApiStores.getEstadosList(payload);
    if (resp.Codigo === 200) {
      const selectedEstado = resp.ListaEstados[0].ListaEstados.find(
        (estado) => estado.IdEstado === shippingAddressInfo.shippingState
      );
      setEstadoSelected(selectedEstado);
    }
  }, []);
  // eslint-disable-next-line no-unused-vars

  useEffect(() => {
    getStatesInfo();
  }, []);

  useEffect(() => {
    setShowEvoHtml(evoResult === 'PENDING' || evoResult === 'SUCCESS');
    setModalOpen(true);
  }, [evoResult, evoHtml]);

  const closeModal = () => {
    setModalOpen(false);
  };

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <h4>{spanish ? content?.HeaderSpanish : content?.HeaderEnglish}</h4>
        <div className={styles.header}>
          <Checked />
          <p>{spanish ? content?.MethodSpanish : content?.MethodEnglish}</p>
        </div>
        <div className={styles.note}>
          <p>{spanish ? content?.NoteSpanish : content?.NoteEnglish}</p>
        </div>
        {isLoading ? <Loading /> : ''}
        <div className={isLoading ? styles.hidden : ''}>
          <Form
            content={content}
            onPaymentFormChange={onPaymentFormChange}
            onSubmitPayment={onSubmitPayment}
            shippingAddressInfo={shippingAddressInfo}
            estadoSelected={estadoSelected}
            showErrorMessage={showErrorMessage}
            errorMessage={errorMessage}
          />
          {showEvoHtml ? (
            <div>
              <StaticBackdropModal isOpen={modalOpen} onClose={closeModal}>
                <div className={styles.modalHeacer}>
                  <div>Pago con autenticación bancaria</div>
                  <button
                    id="btnCloseEvoModal"
                    type="button"
                    onClick={(closeModal, validatePayment)}
                  >
                    <CloseBtn />
                  </button>
                </div>
                <div className={styles.evoContent}>
                  <ScriptEvo htmlString={evoHtml} status={evoResult} />
                </div>
              </StaticBackdropModal>
            </div>
          ) : (
            ''
          )}
        </div>
        {processing && <ProcessingModal content={content} />}
      </div>
    </div>
  );
};

export default Payment;
